import { render, staticRenderFns } from "./Emenu.vue?vue&type=template&id=54536824"
import script from "./Emenu.vue?vue&type=script&lang=js"
export * from "./Emenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports